import { render } from "./ModalSelectSendZaloGroupTemplate.vue?vue&type=template&id=3eaf7652&scoped=true"
import script from "./ModalSelectSendZaloGroupTemplate.vue?vue&type=script&lang=js"
export * from "./ModalSelectSendZaloGroupTemplate.vue?vue&type=script&lang=js"

import "./ModalSelectSendZaloGroupTemplate.vue?vue&type=style&index=0&id=3eaf7652&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eaf7652"]])

export default __exports__